"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var UpdateSaveSearchAction;
(function (UpdateSaveSearchAction) {
    UpdateSaveSearchAction.ON_UPDATE_SAVE_SEARCH_CLOSE = 'ON_UPDATE_SAVE_SEARCH_CLOSE';
    UpdateSaveSearchAction.SET_UPDATE_SAVE_SEARCH_ACTIVE = 'SET_UPDATE_SAVE_SEARCH_ACTIVE';
    UpdateSaveSearchAction.SET_UPDATE_SAVE_SEARCH_DIM = 'SET_UPDATE_SAVE_SEARCH_DIM';
    UpdateSaveSearchAction.SET_UPDATE_SAVE_SEARCH_LOADING = 'SET_UPDATE_SAVE_SEARCH_LOADING';
    UpdateSaveSearchAction.SET_SAVE_SEARCH_SEARCHSETS = 'SET_SAVE_SEARCH_SEARCHSETS';
    UpdateSaveSearchAction.SET_SAVE_SEARCH_SEARCHSETS_FROMREMOTE = 'SET_SAVE_SEARCH_SEARCHSETS_FROMREMOTE';
    UpdateSaveSearchAction.SET_SAVE_SEARCH_SFILTER = 'SET_SAVE_SEARCH_SFILTER';
    UpdateSaveSearchAction.SET_SAVE_SEARCH_NAME = 'SET_SAVE_SEARCH_NAME';
    UpdateSaveSearchAction.SET_SAVE_SEARCH_ID = 'SET_SAVE_SEARCH_ID';
    UpdateSaveSearchAction.REMOVE_SAVE_SEARCHSET = 'REMOVE_SAVE_SEARCHSET';
    UpdateSaveSearchAction.ON_SEARCH_SET_CLICKED = 'ON_SEARCH_SET_CLICKED';
    UpdateSaveSearchAction.SET_SEARCH_SET_NOTIFICATION = 'SET_SEARCH_SET_NOTIFICATION';
    UpdateSaveSearchAction.onCloseClick = typesafe_actions_1.createAction(UpdateSaveSearchAction.ON_UPDATE_SAVE_SEARCH_CLOSE, function (resolve) {
        return function () { return resolve(); };
    });
    UpdateSaveSearchAction.setActive = typesafe_actions_1.createAction(UpdateSaveSearchAction.SET_UPDATE_SAVE_SEARCH_ACTIVE, function (resolve) {
        return function (status) { return resolve(status); };
    });
    UpdateSaveSearchAction.setDim = typesafe_actions_1.createAction(UpdateSaveSearchAction.SET_UPDATE_SAVE_SEARCH_DIM, function (resolve) {
        return function (status) { return resolve(status); };
    });
    UpdateSaveSearchAction.setLoading = typesafe_actions_1.createAction(UpdateSaveSearchAction.SET_UPDATE_SAVE_SEARCH_LOADING, function (resolve) {
        return function (status) { return resolve(status); };
    });
    UpdateSaveSearchAction.setSearchSets = typesafe_actions_1.createAction(UpdateSaveSearchAction.SET_SAVE_SEARCH_SEARCHSETS, function (resolve) {
        return function (searchSets) { return resolve(searchSets); };
    });
    UpdateSaveSearchAction.setSearchSetsFromRemote = typesafe_actions_1.createAction(UpdateSaveSearchAction.SET_SAVE_SEARCH_SEARCHSETS_FROMREMOTE, function (resolve) {
        return function () { return resolve(); };
    });
    UpdateSaveSearchAction.setName = typesafe_actions_1.createAction(UpdateSaveSearchAction.SET_SAVE_SEARCH_NAME, function (resolve) {
        return function (name) { return resolve(name); };
    });
    UpdateSaveSearchAction.setCurrentId = typesafe_actions_1.createAction(UpdateSaveSearchAction.SET_SAVE_SEARCH_ID, function (resolve) {
        return function (id) { return resolve(id); };
    });
    UpdateSaveSearchAction.removeSearchSet = typesafe_actions_1.createAction(UpdateSaveSearchAction.REMOVE_SAVE_SEARCHSET, function (resolve) {
        return function (id) { return resolve(id); };
    });
    UpdateSaveSearchAction.onSearchSetClicked = typesafe_actions_1.createAction(UpdateSaveSearchAction.ON_SEARCH_SET_CLICKED, function (resolve) {
        return function (searchSet) { return resolve(searchSet); };
    });
    UpdateSaveSearchAction.setNotificationSetting = typesafe_actions_1.createAction(UpdateSaveSearchAction.SET_SEARCH_SET_NOTIFICATION, function (resolve) {
        return function (id, enabled, freq) { return resolve({ id: id, enabled: enabled, freq: freq }); };
    });
})(UpdateSaveSearchAction || (UpdateSaveSearchAction = {}));
exports.default = UpdateSaveSearchAction;
